/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 */

import gql from "graphql-tag";

export const UPDATE_TEMPLATE_COSTUME_FEATURE = gql`
  mutation UpdateCostumeFeature(
    $filter: UniqCostumeFeatureFilterInput!
    $update: CostumeFeatureUpdateInput!
  ) {
    updateCostumeFeature(filter: $filter, update: $update) {
      updatedAt
      isBase
    }
  }
`;
